export const COGNITO_CONFIG = {
  REGION: process.env.REACT_APP_REGION ? process.env.REACT_APP_REGION : "us-east-1",
  USER_POOL_ID: process.env.REACT_APP_USER_POOL_ID ? process.env.REACT_APP_USER_POOL_ID : "us-east-1_RsYLGiInq",
  APP_CLIENT_ID: process.env.REACT_APP_APP_CLIENT_ID ? process.env.REACT_APP_APP_CLIENT_ID : "4bfstb7m8bb6oqu92mu1pvbf9r"
};

const isLocalMode = process.env.REACT_APP_LOCAL_AUTH === 'true';
const localApiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8080';
const localGraphQLUrl = process.env.REACT_APP_LOCAL_GQL_URL || 'http://localhost:8081/graphql';
const localGraphQLWsUrl = process.env.REACT_APP_LOCAL_GQL_WS_URL || 'ws://localhost:8081/graphql';

export const API_CONFIG = {
  URL_BASE: isLocalMode ? localApiUrl : (process.env.REACT_APP_API_URL_BASE || "https://api.dev.halespring.com"),
  URL2_BASE: isLocalMode ? localApiUrl : (process.env.REACT_APP_API2_URL_BASE || "https://api.dev.halespring.com"),
  URL3_BASE: isLocalMode ? localApiUrl : (process.env.REACT_APP_API3_URL_BASE || "https://api.dev.halespring.com"),
  GQL_BASE: isLocalMode ? localGraphQLUrl : (process.env.REACT_APP_GQL_URL_BASE || "https://gql.dev.halespring.com/graphql")
};

export const STRIPE_CONFIG = {
  API_KEY: process.env.REACT_APP_STRIPE_API_KEY ? process.env.REACT_APP_STRIPE_API_KEY : "pk_test_51OP3bAEuUxjankBhBsbt6nawWjPzDGe0HG4UDTjmPNJmNkCFuvlbghJtr8nSIOvVTK05x7nycFkARaw3pgr1OmOe00rq42mywY"
};

export const PERSONA_CONFIG = {
  TEMPLATE_ID: process.env.REACT_APP_PERSONA_TEMPLATE_ID ? process.env.REACT_APP_PERSONA_TEMPLATE_ID : "itmpl_rr7T3CegzCbbSyJ2sWMXrs7oMcsn",
  ENVIRONMENT_ID: process.env.REACT_APP_PERSONA_ENVIRONMENT_ID ? process.env.REACT_APP_PERSONA_ENVIRONMENT_ID : "sandbox"
};

export const CRONOFY_CONFIG = {
  CLIENT_ID: process.env.REACT_APP_CRONOFY_CLIENT_ID ? process.env.REACT_APP_CRONOFY_CLIENT_ID : (process.env.NODE_ENV === 'development' ? "toUiYhuqvm4jwgLYsZq0DpNJNQMd7rPO" : "")
};


export const FEATURE_CONFIG = {
  COMING_SOON: process.env.REACT_APP_COMING_SOON ? process.env.REACT_APP_COMING_SOON === "true" : false,
  VIDEO_CHAT: process.env.REACT_APP_VIDEO_CHAT ? process.env.REACT_APP_VIDEO_CHAT === "true" : true
};
